(() => {
  function initialize(root) {
    root.querySelectorAll('[data-discover-wayfinder]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const input = form.querySelector('[name="origin"]');
      input.addEventListener('input', () => input.setCustomValidity(''));
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const origin = input.value.trim();
        if (!origin) {
          input.setCustomValidity(form.dataset.required);
          input.reportValidity();
          return;
        }
        const destination = form.dataset.destination;
        let url;
        if (event.submitter?.value === 'maps') {
          url = new URL('https://www.google.com/maps/dir/');
          url.search = new URLSearchParams({api: '1', origin, destination, travelmode: 'driving'}).toString();
        } else {
          url = new URL('https://www.rome2rio.com/s/' + encodeURIComponent(origin) + '/' + encodeURIComponent(destination));
        }
        window.open(url.href, '_blank', 'noopener,noreferrer');
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
